import Typography from "@mui/material/Typography"

export default function Head({ headName, subHeadName = "", ...others }) {
  return (
    <>
      <Typography
        variant="h1"
        sx={{
          pb: 2,
          fontWeight: "medium",
          color: "grey.600"
        }}
        {...others}
      >
        {headName}
      </Typography>
      {subHeadName && <Typography variant="h5">{subHeadName}</Typography>}
    </>
  )
}
